/**
 * Convience functions for handling arrays.
 */

/**
 * Adds the passed item to the provided array, if the array is valid. Otherwise, return a new array.
 *
 * @param {Array} array The array to modify.
 * @param {*} item The item to add to the array.
 *
 * @returns {Array} Either a new array or the updated array.
 */
export function addToArray(array, item) {
  if (!Array.isArray(array)) {
    return [item];
  }

  return array.concat(item);
}

/**
 * Function to alphabetize an array by the key provided
 * @param {*} arr of items to alphabetize
 * @param {*} key to alphabetize the array by
 * @returns
 */
export const alphabetizeByKey = (arr, key) => {
  if (arr && key) {
    const origArray = [...arr];
    return origArray.sort((a, b) => {
      if (a[key].toLowerCase() < b[key].toLowerCase()) {
        return -1;
      }
      if (a[key].toLowerCase() > b[key].toLowerCase()) {
        return 1;
      }
      return 0;
    });
  }
};
